module.exports = __webpack_public_path__ + "f8a703ccf9ce81f9a8bff2c2c8d02bc7.png";